import React from "react";
import { Text } from "@chakra-ui/react"
import { IconButton } from "@mui/material"
import { BsXCircleFill } from "react-icons/bs"
import { useTranslation } from "react-i18next";

export const NotFoundResults=({title})=>{

    const { t } = useTranslation('enterprises');

    return(
        <Text className='text-red-500 text-center my-2 text-xl'>{title ?? t('not_found_result')}</Text>

    )
}

export const CloseModalButton = ({handleClose, iconColor, dataCy})=>{


    return (
        <IconButton
        edge="start"
        color="inherit"
        onClick={handleClose}
        aria-label="close"
        data-cy={dataCy}
    >
        <BsXCircleFill color={iconColor ?? ''} className='cursor-pointer'   />

    </IconButton>
    )
}